/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import queryString from 'querystring';

import { ApiClient } from '../types/api/ApiClient';
import { AddOrphanToWhitelistRequest } from '../types/superuser/AddOrphanToWhitelistRequest';
import { DeleteOrphanFromWhitelistRequest } from '../types/superuser/DeleteOrphanFromWhitelistRequest';
import { DeleteSuperuserClusterRequest } from '../types/superuser/DeleteSuperuserClusterRequest';
import { OrphansList } from '../types/superuser/OrphansList';
import { getApiEndpoint } from '../utils/getApiEndpoint';
import { apiClientFactory } from '../utils/http-client/apiClientFactory';
import { axiosInstanceFactory } from '../utils/http-client/axiosInstanceFactory';
import { axiosJwtTokenInterceptor, axiosUnauthorizedInterceptor } from '../utils/http-client/axiosInterceptors';

class SuperuserClusterApiServiceClass {
  private api: ApiClient;

  constructor() {
    this.api = apiClientFactory(
      axiosInstanceFactory(
        { baseURL: getApiEndpoint() },
        [axiosJwtTokenInterceptor],
        [[undefined, axiosUnauthorizedInterceptor]],
      ),
    );
  }

  fetchOrphans = () => this.api.get<OrphansList>('/administration/cluster');

  deleteCluster = ({ data }: { data: DeleteSuperuserClusterRequest }) =>
    this.api.del(`/administration/cluster?${queryString.encode({ ...data })}`);

  addOrphanToWhitelist = ({ data }: { data: AddOrphanToWhitelistRequest }) =>
    this.api.post(`/administration/cluster/whitelist?${queryString.encode({ ...data })}`, {});

  deleteOrphanFromWhitelist = ({ data }: { data: DeleteOrphanFromWhitelistRequest }) =>
    this.api.del(`/administration/cluster/whitelist?${queryString.encode({ ...data })}`);
}

export const SuperuserClusterApiService = new SuperuserClusterApiServiceClass();
